import {Component, Input, OnInit} from '@angular/core';
import {BasePlace} from "../../../services/restaurant.service";

@Component({
  selector: 'app-show-place',
  templateUrl: './show-place.component.html',
  styleUrls: ['./show-place.component.scss']
})
export class ShowPlaceComponent implements OnInit {
  @Input() place:BasePlace;
  constructor() { }

  ngOnInit() {
  }

}
